<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xs12 sm8>
        <v-card class="elevation-12 default-border">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Caixa Diário</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form
              v-model="formularioCadastroValido"
              ref="formularioCadastroRef"
            >
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 md8>
                    <v-select
                      v-model="cadastroModel.produto"
                      color="secondary"
                      :items="listaProdutos"
                      :rules="regras.branco"
                      @change="onChange($event)"
                      item-text="nome"
                      prepend-icon="business_center"
                      label="Produtos"
                      return-object
                      riquired
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      ref="txtvalorTotalFormatado"
                      v-model="valorTotalFormatado"
                      color="secondary"
                      prepend-icon="attach_money"
                      label="Valor"
                      disabled
                      v-money="maskMoney"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-select
                      v-model="cadastroModel.tipoPagamentoPrimario"
                      color="secondary"
                      :items="listaTipoPagamento"
                      :rules="regras.branco"
                      item-text="nome"
                      prepend-icon="business_center"
                      label="Forma de Pagamento Primária"
                      return-object
                      riquired
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      ref="txtvalorPrimarioFormatado"
                      v-model="valorPrimarioFormatado"
                      color="secondary"
                      prepend-icon="attach_money"
                      label="Valor"
                      v-money="maskMoney"
                      :rules="regras.branco"
                      riquired
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 md8>
                    <v-select
                      v-model="cadastroModel.tipoPagamentoSecundario"
                      color="secondary"
                      :items="listaTipoPagamento"
                      item-text="nome"
                      prepend-icon="business_center"
                      label="Forma de Pagamento Secundária"
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 md4>
                    <v-text-field
                      ref="txtvalorSecundarioFormatado"
                      v-model="valorSecundarioFormatado"
                      color="secondary"
                      prepend-icon="attach_money"
                      label="Valor"
                      v-money="maskMoney"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              id="voltar"
              color="primary"
              class="grey--text text--darken-1"
              :to="{ name: 'Pessoas' }"
              flat
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              id="finalizar"
              color="primary"
              class="default-border"
              depressed
              @click="finalizar"
              :disabled="disableBtnFinalizar || calculoProduto || !formValid"
              >Finalizar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="5000"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      bottom
      multi-line
      v-model="snackbarModel.mostrar"
    >
      {{ snackbarModel.text }}
      <v-btn
        flat
        dark
        @click.native="
          `${
            snackbarModel.sucesso
              ? go('Contas')
              : (snackbarModel.mostrar = false)
          }`
        "
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import cipher from "@/helpers/cipher.js";
import customFormat from "@/helpers/custom-format.js";
import jwt from "@/helpers/jwt";
import { VMoney } from "v-money";
export default {
  name: "Caixa",
  directives: {
    money: VMoney,
  },
  data: () => ({
    formularioCadastroValido: false,
    disableBtnFinalizar: false,
    valorTotalFormatado: 0.0,
    valorPrimarioFormatado: 0.0,
    valorSecundarioFormatado: 0.0,
    listaProdutos: [],
    listaTipoPagamento: [
      {
        idTipoPagamento: 1,
        nome: "Dinheiro",
      },
      {
        idTipoPagamento: 2,
        nome: "Debito",
      },
      {
        idTipoPagamento: 3,
        nome: "Cartão Avista",
      },
      {
        idTipoPagamento: 4,
        nome: "Cartão Parcelado",
      },
      {
        idTipoPagamento: 5,
        nome: "Pix",
      },
    ],
    cadastroModel: {
      valorTotal: null,
      usuario: {
        idUsuario: jwt.decryptToken().id,
      },
      produto: null,
      pessoa: { idPessoa: null },
      tipoPagamentoPrimario: null,
      valorPrimario: null,
      tipoPagamentoSecundario: null,
      valorSecundario: null,
      conta: {
        idConta: jwt.decryptToken().idconta,
      },
    },
    snackbarModel: {
      mostrar: false,
      text: "",
      sucesso: false,
    },
    regras: {
      branco: [(v) => !!v || "Você não pode deixar este campo em branco"],
    },
    maskMoney: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    },
  }),
  computed: {
    formValid: function () {
      return this.formularioCadastroValido;
    },
    calculoProduto: function () {
      if (
        this.cadastroModel.produto == null ||
        this.cadastroModel.valorPrimario == 0
      ) {
        return true;
      }

      if (
        (this.cadastroModel.tipoPagamentoSecundario == null) &
        (this.cadastroModel.valorSecundario > 0)
      ) {
        return true;
      }

      if (
        (this.cadastroModel.tipoPagamentoPrimario != null) &
        (this.cadastroModel.tipoPagamentoSecundario != null)
      )
        if (
          this.cadastroModel.tipoPagamentoPrimario.idTipoPagamento ==
          this.cadastroModel.tipoPagamentoSecundario.idTipoPagamento
        ) {
          return true;
        }
      {
      }

      return (
        this.cadastroModel.valorPrimario + this.cadastroModel.valorSecundario !=
        this.cadastroModel.produto.valorFinal
      );
    },
    customFormatComputed: function () {
      return customFormat;
    },
  },
  mounted: function () {
    this.buscarProdutos();
  },
  watch: {
    valorTotalFormatado: function (val) {
      this.cadastroModel.valorTotal = customFormat.removeMoneyFormat(val);
    },
    valorPrimarioFormatado: function (val) {
      this.cadastroModel.valorPrimario = customFormat.removeMoneyFormat(val);
    },
    valorSecundarioFormatado: function (val) {
      this.cadastroModel.valorSecundario = customFormat.removeMoneyFormat(val);
    },
  },
  methods: {
    onChange(event) {
      const self = this;
      self.$refs.txtvalorTotalFormatado.$el.getElementsByTagName(
        "input"
      )[0].value = parseFloat(event.valorFinal)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\,)/g, "$&.");
    },
    buscarProdutos: function () {
      const self = this;
      const item = jwt.decryptToken();
      if (item != null) {
        self.$http
          .get(
            `${process.env.URL_API}/produto/v1/busca/conta/ativo/validos/` +
              jwt.decryptToken().idconta,
            {
              headers: {
                Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("token")),
              },
            }
          )
          .then(function (response) {
            self.listaProdutos = response.data;
          });
      } else {
        self.go("Login");
      }
    },
    finalizar: function () {
      const self = this;
      self.$store.commit("startLoading");
      if (self.$refs.formularioCadastroRef.validate()) {
        const item = jwt.decryptToken();
        if (item != null) {
          if (self.$route.params.id) {
            self.cadastroModel.pessoa.idPessoa = parseInt(
              cipher.decrypt(this.$route.params.id)
            );

            if (self.cadastroModel.tipoPagamentoSecundario != null & self.cadastroModel.valorSecundario == 0) {
              self.cadastroModel.tipoPagamentoSecundario = null;
            }

            self.$http
              .post(
                `${process.env.URL_API}/contasreceber/v1/cadastro`,
                self.cadastroModel,
                {
                  headers: {
                    Authorization:
                      "Bearer " + JSON.parse(localStorage.getItem("token")),
                  },
                }
              )
              .then(function (response) {
                const data = response.data;
                if (data.sucesso) {
                  self.disableBtnFinalizar = data.sucesso;

                  if (item.idtipousuario > 1) {
                    self.go("HistoricoCaxia", {
                      snackbarText: data.mensagem,
                      snackbarMostrar: true,
                      snackbarSucesso: data.sucesso,
                    });
                  } else {
                    self.go("Pessoas", {
                      snackbarText: data.mensagem,
                      snackbarMostrar: true,
                      snackbarSucesso: data.sucesso,
                    });
                  }
                } else {
                  self.snackbarModel.text = data.mensagem;
                  self.snackbarModel.mostrar = true;
                  self.snackbarModel.sucesso = data.sucesso;
                  self.disableBtnFinalizar = data.sucesso;
                }
              })
              .catch(function (error) {
                self.snackbarModel.text = error.response.data.message;
                self.snackbarModel.sucesso = false;
                self.snackbarModel.mostrar = true;
                self.disableBtnFinalizar = false;
              });
          }
        } else {
          self.go("Login");
        }
      }
      self.$store.commit("endLoading");
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (this.$router.currentRoute.name != routeName) {
        if (!routeParams) {
          self.$router.push({ name: routeName });
        } else {
          self.$router.push({ name: routeName, params: routeParams });
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/caixa/Caixa.vue